import { MyAccount } from '@online-webinar/account';
import { RouterType } from '@online-webinar/router';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/account/$tab'].update({
        staticData: {
            title: {
                page: {
                    param: 'tab',
                    keys: {
                        profile: 'Account.Tab.Profile',
                        password: 'Account.Tab.Password',
                        manage: 'Account.Tab.ManageAccount',
                        'api-keys': 'Account.Tab.ApiKeys'
                    }
                },
                section: 'Account.Button'
            }
        },
        component: authGuard(MyAccount)
    });
};
